import styles from "./Home.module.scss";
import { HomeIntro } from "./Components";
import HomeFaculty from "./Components/HomeFaculty";
import HomeInstitution from "./Components/HomeInstitution";
import HomeUnit from "./Components/HomeUnit";
import HomeVenue from "./Components/HomeVenue";
import HomeConcept from "./Components/HomeConcept";
import HomeFeature from "./Components/HomeFeature";
import { useRef } from "react";
import HomeHeroSection from "./Components/HomeHeroSection";
import HomeProcessSteps from "./Components/HomeProcessSteps";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const introRef = useRef(null);
  const onClickExplore = () => {
    window.scrollTo({
      behavior: "smooth",
      block: "start",
      top: introRef.current.offsetTop,
    });
  };

  const currentUrl = window.location.href.split("?")[0];

  return (
    <div className={styles["home"]}>
      <Helmet>
        <title>Academic Keyword Explorer &amp; Research Trends | Academic Explorer</title>
        <meta name="description" content="Explore our world of academic research and keywords." />
        <meta property="og:title" content="Academic Keyword Explorer & Research Trends | Academic Explorer" />
        <meta property="og:description" content="Explore our world of academic research." />
        <link rel="canonical" href={currentUrl} />
      </Helmet>
      <HomeIntro onClickExplore={onClickExplore} />
      <HomeProcessSteps />
      {/* <div ref={introRef} className={styles["hero-section-intro"]}>
        <HomeHeroSection />
      </div> */}
      {/* <HomeFaculty />
      <HomeInstitution />
      <HomeUnit />
      <div className={styles["divider__container"]}>
        <div className={styles["divider"]} />
      </div>
      <HomeVenue />
      <HomeConcept /> */}
      <HomeFeature />
    </div>
  );
};

export default Home;
